import styled from 'styled-components'

const Recipe = styled.div`

  display: flex;
  flex-direction: column;

  margin: 8px;
  @media (max-width: 1120px) {
    margin: 4px;
  }
`

const RecipeInfo = styled.div`
  display: flex;
  flex-direction: row;
`

const RecipeDetails = styled.div`
  flex: 1 0;
  display: flex;
  flex-direction: column;
`

const Inputs = styled.div`
  flex: 1 0;
  padding-right: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  @media (max-width: 1120px) {
    padding-right: 8px;
  }

  & > div:first-child {
      margin-right: 10px;
  }
  & > div:last-child {
      margin-left: 10px;
  }
`


const InputBlock = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 450px;
  flex: 1 1;
`

const Tags = styled.div`
  flex: 1 1;
  padding: 10px 0;
  & > div:first-child {
    margin-bottom: 0;
  }
`

const RecipeImage = styled.div`
  padding-left: 16px;
  margin-top: 4px;
  @media (max-width: 1120px) {
    padding-left: 8px;
  }
`

const ButtonsBlock = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-bottom: 21px;

  & > div:first-child {
    button {
      margin-left: 0;
    }
  }
`

const DescriptionBlock = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1 1;
`

const Variations = styled.div`
`

const Variation = styled.div`
  padding: 5px;
`

const Times = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
  & > div {
    margin-right: 20px;
    max-width: 170px;
    min-width: auto;
  }
`

const LevelsBlock = styled.div`
  display: table;
`

const Level = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  display: table-row;

  & > div {
    display: table-cell;
    padding-bottom: 40px;
    vertical-align: middle;
  }

`
const LevelValues = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: 20px;
  & > div {
    margin: 0 10px;
  }
`

const Ingreditens = styled.div`
  flex: 1 1;
  display: flex;
  flex-direction: row;
`
const IngredientsList = styled.div`
  display: flex;
  flex-direction: column;
  border-right: 2px solid #0091FF;
  padding: 10px 30px 10px 10px;
  overflow-y: auto;
  max-height: 600px;
`

const Steps = styled.div`
  flex: 1 1;
  display: flex;
  flex-direction: row;
`
const StepsList = styled.div`
  display: flex;
  flex-direction: column;
  border-right: 2px solid #0091FF;
  padding: 10px 30px 10px 10px;
  overflow-y: auto;
  max-height: 1380px;
`

export const Locked = styled.div`
  color: white !important;
  background: red;
  padding: 20px;
  margin: 0 5px 10px 8px;
  border-radius: 6px;
  font-size: 18px;
  font-weight: bold;
  display: flex;
  flex-direction: row;
  align-items: center;
  & > * {
    color: white !important;
  }
  & > svg {
    font-size: 22px;
    margin-right: 4px;
  }
`

export default {
  Recipe,
  RecipeInfo,
  RecipeDetails,
  Inputs,
  InputBlock,
  Tags,
  RecipeImage,
  ButtonsBlock,
  DescriptionBlock,
  Variations,
  Variation,
  Times,
  LevelsBlock,
  Level,
  LevelValues,
  Ingreditens,
  IngredientsList,
  Steps,
  StepsList,
  Locked,
}
